// document.addEventListener("DOMContentLoaded", function() {
//   var endlessScroll = new Ajaxinate({
//     container: '#main-collection-product-grid',
//     pagination: '#AjaxinatePagination',
//     method: 'click',
//     offset: 1000
//   });
// });
var pInfScrLoading = false;
var pInfScrDelay = 250;
function pInfScrExecute() {
  if (pInfScrLoading) return;
  pInfScrNode = $('.more').last();
  pInfScrURL = $('.more a').last().attr("href");
  if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
    $.ajax({
      type: 'GET',
      url: pInfScrURL,
      beforeSend: function() {
        pInfScrLoading = true;
        pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0582/5282/0666/files/ajax-loader.gif?v=1633682512" />');
        pInfScrNode.hide();
      },
      success: function(data) {
        // remove loading feedback
        pInfScrNode.next().remove();
        pInfScrNode.remove();
        var filteredData = $(data).find("#main-collection-product-grid").html();
        $("#main-collection-product-grid").append(filteredData);
        pInfScrLoading = false;
        attachClickEvent();
      },
      dataType: "html"
    });
  }
}
function attachClickEvent(){
  $('.more a').click(function(event){
    event.preventDefault();
    pInfScrExecute();
    event.stopPropagation();
    return false;
  });

  // Save scroll position and loaded products before navigating to the product page
  // $('#main-collection-product-grid a').click(function() {
  //   sessionStorage.setItem('scrollPosition', $(window).scrollTop());
  //   saveLoadedProducts();
  // });
}

// Save the HTML content of the loaded products and scroll position
function saveLoadedProducts() {
  var loadedProducts = $("#main-collection-product-grid").html();
  sessionStorage.setItem('loadedProducts', loadedProducts);
  var scrollPosition = $(window).scrollTop();
  sessionStorage.setItem('scrollPosition', scrollPosition);
  sessionStorage.setItem('collectionURL', window.location.href);
}

// Restore scroll position and loaded products when the page is loaded
$(document).ready(function() {
  if (window.location.pathname.includes('/collections')) {
    var scrollPosition = sessionStorage.getItem('scrollPosition');
    var loadedProducts = sessionStorage.getItem('loadedProducts');
    var collectionURL = sessionStorage.getItem('collectionURL');
    if (loadedProducts && collectionURL === window.location.href) {
      $("#main-collection-product-grid").html(loadedProducts);
      sessionStorage.removeItem('loadedProducts');
    }
    if (scrollPosition && collectionURL === window.location.href) {
      $(window).scrollTop(scrollPosition);
      sessionStorage.removeItem('scrollPosition');
    }
    attachClickEvent();
  }
});

// Save state when clicking on a product link
$(document).on('click', '.product_grid_inr a', function() {
  saveLoadedProducts();
});

// Save scroll position before the user leaves the page
$(window).on('beforeunload', function() {
  sessionStorage.setItem('scrollPosition', $(window).scrollTop());
});

// Restore scroll position when the page is shown (including back navigation)
$(window).on('pageshow', function(event) {
  if (event.originalEvent.persisted) {
    var scrollPosition = sessionStorage.getItem('scrollPosition');
    if (scrollPosition) {
      $(window).scrollTop(scrollPosition);
      sessionStorage.removeItem('scrollPosition');
    }
  }
});

$(document).ready(function () {
  attachClickEvent();
});
function deferFilterjQuery() {
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){
          // On load/reload
          var pt_on_load = function() {
            
            // Accordion
            
              
              $('.filter-menu').each(function(){ $(this).find('.filter-group:visible').not('.has_group_selected, .refine-header, .refine-header, .pt-display-dropdown').first().toggleClass('pt-group-expanded'); });
              
              if ($('.filter-group').hasClass('pt-group-expanded')) {
                $('.filter-group.pt-group-expanded h4').attr('aria-expanded', 'true');
              } else {
                $('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').find('h4').attr('aria-expanded', 'false');
              }
            

            // Search
            $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

            // Drop downs
            $('.pt-display-dropdown').each(function( index ) {
                $(this).find('h4').after($(this).find('.filter-clear'));
            });

            $('.pt-display-dropdown .scroll-content').each(function( index ) {
              if($(this).parent().find('.menu-trigger').length === 0) {
                if($(this).find('li.selected').length) {
                  var selected = $.map(
                    $(this).find('li.selected a'),
                    function(element){
                      return $(element).text();
                    }
                  ).join(", ");

                  if (selected.length < 30) {
                    $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">' + selected +'</div>');
                  } else {
                    $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">' + $(this).find('li.selected').length + ' Selected </div>');
                  }
                }
                else {
                  $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
                }
              }
            });

            //Sticky Mode
            

            // View more
            

            $('.filter-menu li a').attr('title', function() {
              return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
            });

            // Handle nested filters
            var splitPath = function(url) {
              var splitUrl =  url.split('?')[0].split('#')[0].split('/');
              return splitUrl;
            }

            var getCollection = function(url) {
              var splitUrl = splitPath(url);
              return splitUrl[2];
            }

            var getTags = function(url) {
              var splitUrl = splitPath(url);
              return (splitUrl[3] || '').split('+');
            }

            var getCommonCollection = function(url_top, url_nested) {
              var collection_top = getCollection(url_top);
              var collection_nested = getCollection(url_nested);
              if (collection_top !== collection_nested) {
                return 'all';
              }
              return collection_top;
            }

            var getCommonTags = function(url_top, url_nested) {
              var tags_top = getTags(url_top);
              var tags_nested = getTags(url_nested);

              return tags_top.filter(function(n) {
                return tags_nested.indexOf(n) > -1;
              });
            }

            var getCommonUrl = function(url_top, url_nested) {
              var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

              var lastChar = val.slice(-1);
                    if (lastChar == '/') {
                    val = val.slice(0, -1);
                }

              return val;
            }

            var clearNestedParent = $('.pt-display-nested').prev().each(function() {
              var clearNested = $(this).next().find('a.filter-clear').attr('href');
              if (!clearNested) return;
              var clearLink = $(this).find('a.filter-clear');
              clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
              var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
                $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested));
              })
            })
            
            // Ajax
            
            if (window.location.pathname.lastIndexOf('/collections/', 0) === 0) {
              var pjax = new Pjax({
                elements: '.pt-apply-form,#MainContent .pagination a, #MainContent .filter-group.clear-all-current a',
                selectors: ['title', '#MainContent'],scrollTo: false,
                timeout: 10000
              });
            }
            
          }

          pt_on_load();

          // Add selected class before page load
          $(document).on('click', '.filter-menu .filter-group .collection-container a', function () {
            $(this).parent().toggleClass('selected');
            if ($(this).closest('.filter-group').hasClass('has_group_selected')) {
              $(this).closest('li').siblings().removeClass('selected');
            }
          });

          // Mobile filter button
          
          $(document).on('click', '.filter-menu .pt-mobile-header a', function(e){
            if(e.handled !== true) {
              if ($('.pt-nav-toggle').hasClass('active')) {
                $('.filter-menu').removeClass('pt-expand');
                $('.pt-display-dropdown .scroll-content').hide();
                $('.pt-nav-toggle').attr('aria-expanded', 'false');
                $('.pt-nav-toggle').attr('aria-label', 'Show Filters');
              } else {
                $('.filter-menu').addClass('pt-expand');
                $('.pt-nav-toggle').attr('aria-expanded', 'true');
                $('.pt-nav-toggle').attr('aria-label', 'Hide Filters');
              }

              $('.pt-nav-toggle').toggleClass('active');
              e.preventDefault();
              e.handled = true;
            }
          });

          

          // Accordion
          
          $(document).on('click', '.filter-menu h4', function(e){
            $(this).closest('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').toggleClass('pt-group-expanded');
            if ($(this).closest('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').hasClass('pt-group-expanded')) {
              $(this).closest('.filter-group h4').attr('aria-expanded', 'true');
            } else {
              $(this).closest('.filter-group h4').attr('aria-expanded', 'false');
            }
            e.preventDefault();
          });
          
          $(document).on('keydown', '.filter-menu h4', function(e){
            if(e.which == 13 || e.which == 32) {
              e.preventDefault();
              $(this).click();
            }
          });
          

          // Search
          $(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            $(this).closest('.filter-group').find('li').each(function () {
              if ($(this).text().toLowerCase().search(value) > -1) {
                $(this).show(100);
              } else {
                $(this).hide(100);
              }
            });
          });

          // Drop downs
          $(document).on('click','.pt-display-dropdown .menu-trigger', function() {
            $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
            $(this).next('.scroll-content').slideToggle('fast');
            $(this).next('.scroll-content').toggleClass('dropdown-open')
            if ($(this).next('.scroll-content').hasClass('dropdown-open')) {
              $(this).attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection expanded');
            } else {
              $(this).attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
            }
          });
          $(document).on('click','.filter_button',function(e){
          	e.preventDefault();
            $(this).closest('.filter_col').addClass('active').siblings().removeClass('active');
            $('body').toggleClass('open-filter');
             // $('body').toggleClass('overlaycollection');
            $('body').removeClass('accountopen CartOpen open_search menu-open');  
            $('.nav-sort-orders').slideUp();
            var numOfSelected = $('.filter-menu .filter-group li.selected:visible').length;
            if(numOfSelected>0){
              $('.pt-apply-form .pt-apply').text($('.pt-apply-form .pt-apply').data('text').trim() + ' (' + numOfSelected + ')');
              $('.pt-apply-form .pt-apply').removeClass('pt-apply-disabled');
            }else{
              $('.pt-apply-form .pt-apply').text($('.pt-apply-form .pt-apply').text().trim());
              $('.pt-apply-form .pt-apply').addClass('pt-apply-disabled');
            }
          });
          $(document).on('click','.sort_button',function(e){
          	$(this).closest('.filter_col').addClass('active').siblings().removeClass('active');
            $(this).next('.nav-sort-orders').slideToggle();
            return false;
          });
          $(document).on("click", function(e) {
            if ($(e.target).is(".nav-sort-orders") === false) {
              $('.nav-sort-orders').slideUp();  
            }            
          });
          $(document).on('click','.pt-apply',function(e){
            $('body').removeClass('open-filter');
          });
          $(document).on('keydown', '.pt-display-dropdown .menu-trigger', function(e) {
            if(e.which == 13 || e.which == 32 ) { // return or space keys
              e.preventDefault();
              $(this).click();
            }
          });
          
          $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
            $(this).removeClass('dropdown-open');
            $(this).slideUp('fast');
            $(this).prev('.menu-trigger').attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
          });
          
          $(document).on('focusout', '.pt-display-dropdown .scroll-content li:last-child', function() {
            $(this).closest('.scroll-content').removeClass('dropdown-open');
            $(this).closest('.scroll-content').slideUp('fast');
            $(this).closest('.scroll-content').prev('.menu-trigger').attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
          });

          // Apply button
          
          $(document).on('click', '.filter-group li.collection-container a, .filter-group a.filter-clear', function(e) {
            e.preventDefault();
            var current_url = $(this).attr('href');           
            $('.filter-menu').fadeTo('slow', 0.8);
            $('.filter-group').addClass('pt-group-disabled');
            // load new filters
            $.get(current_url, function( data ) {
              var elem = $(data).find('.filter-menu')[0] || $(data);
              $('.filter-menu').replaceWith(elem).fadeTo('fast', 1.0);
              $('.pt-apply-form').attr('action', current_url);
              $('.pt-apply-form .pt-apply').removeClass('pt-apply-disabled');
              pt_on_load();
              var numOfSelected = $('.filter-menu .filter-group li.selected:visible').length;
              if(numOfSelected>0){
                $('.pt-apply-form .pt-apply').text($('.pt-apply-form .pt-apply').data('text').trim() + ' (' + numOfSelected + ')');
              }else{
                $('.pt-apply-form .pt-apply').text($('.pt-apply-form .pt-apply').text().trim());
                $('.pt-apply-form .pt-apply').addClass('pt-apply-disabled');
              }
               // open mobile accordion after matching filters loaded
              $('.filter-menu .pt-mobile-header a').trigger('click');
              
            });
          });
          

          // Ajax
          
            var body = document.querySelector('body');
            document.addEventListener('pjax:send', function(){  
              body.classList.add("pt-ajax-loading"); 
            });
            document.addEventListener('pjax:complete', function(){ 
              body.classList.remove("pt-ajax-loading");
              pt_on_load();
              ;
// 			  var endlessScroll = new Ajaxinate({
//                 container: '#main-collection-product-grid',
//                 pagination: '#AjaxinatePagination',
//                 method: 'click',
//                 offset: 1000
//               });
              attachClickEvent();
            });
          
      });
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}
deferFilterjQuery();
